import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbValidators} from "../../../../../shared/validators/DbValidators";
import {Config} from "../../../../../config/config";
import {Utils} from "../../../../../shared/utils/utils";
import {CreateWebsiteMode} from "../../models/create-website-option.model";
import {
  IWebsiteInstallationForm,
} from "../../models/website-install-data.model";
import {CreateWebsiteHelpersService} from "../../../../../services/local/create-website-helpers.service";
import {HostingService} from "../../../../../websites/website/hosting/hosting.service";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {UserSubscription, UserSubscriptionCategory} from "../../../../../user/user-subscription";

@Component({
    selector: 'db-create-website-install-blank',
    templateUrl: './create-website-install-blank.component.html',
    styleUrls: ['./create-website-install-blank.component.scss'],
    standalone: false
})
export class CreateWebsiteInstallBlankComponent implements OnChanges, OnInit {

  @Input() loading = false;
  @Input() suggestedSubdomain = '';
  @Input() configHostname: string;
  @Input() createWebsiteMode: CreateWebsiteMode = 'single';
  @Input() regions: any = [];
  @Input() userSubscription: UserSubscription;

  @Output() readonly resized = new EventEmitter<void>();
  @Output() readonly submitted = new EventEmitter<IWebsiteInstallationForm>();
  @Output() readonly validationFailed = new EventEmitter<void>();

  public formSubmitted = false;
  public showDomainField: boolean = false;

  public get shouldShowHostnameTooltip(): boolean {
    return this.configHostname && this.configHostname.length > 13;
  }
  public multisiteTypes = [
    {value: 'subdirectory', slug: 'Subdirectory'},
    {value: 'subdomain', slug: 'Subdomain'},
  ];
  public createWebsiteForm: FormGroup = new FormGroup({
    multisiteType: new FormControl(null),
    websiteTitle: new FormControl('', [DbValidators.trimStart, Validators.required]),
    region: new FormControl('', [Validators.required]),
    subdomain: new FormControl('', [DbValidators.trim, Validators.required, Validators.pattern('^([a-z0-9]+(-[a-z0-9]+)*)$')]),
    domain: new FormControl(''),
    userName: new FormControl('', [DbValidators.trimStart, Validators.required, Validators.pattern('^[A-za-z\\d\\-_*.@\\s]+$')]),
    password: new FormControl('',  [DbValidators.trim, Validators.required, Validators.pattern('^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[\\w~@#$%^&*+=`|{}:;!.?()\\[\\]-]{8,}$')]),
  });

  protected readonly UserSubscription = UserSubscription;
  protected readonly UserSubscriptionCategory = UserSubscriptionCategory;

  constructor(
    private _createWebsiteHelpersService: CreateWebsiteHelpersService,
    private _hostingService: HostingService,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['createWebsiteMode']) {
      this.createWebsiteForm.get('multisiteType').setValue(changes['createWebsiteMode'].currentValue === 'single' ? null : 'subdirectory');
    }
  }

  ngOnInit() {
    this.suggestedSubdomain && this.createWebsiteForm.get('subdomain').setValue(this.suggestedSubdomain);
    this._setAvailableRegion();
  }

  private _setAvailableRegion(): void {
    const availableRegion = this.regions.find(({isAvailable}) => isAvailable);
    availableRegion && this.createWebsiteForm.get('region').setValue(availableRegion.value);
  }

  public generateRandomPassword(): void {
    const randomPassword = Utils.generateRandomPassword(12);
    this.createWebsiteForm.get('password').setValue(randomPassword);
  }

  public showDomain(): void {
    this.showDomainField = true;
    this.resized.emit();
  }

  private _checkSubdomain(): void {
    this._createWebsiteHelpersService.checkSubDomain(this.createWebsiteForm.value.subdomain)
      .then(response => {
        if (!response.success) {
          this.createWebsiteForm.get('subdomain').setErrors({taken: response.message});
          this.validationFailed.emit();
          return;
        }
        this.createWebsiteForm.value.domain ? this._checkDomain() : this._create();
      });
  }

  private _checkDomain(): void {
    this._createWebsiteHelpersService.checkDomain(this.createWebsiteForm.value.domain)
      .then(response => {
        if (!response.success) {
          this.createWebsiteForm.get('domain').setErrors({server: response.message});
          this.validationFailed.emit();
          return;
        }
        this._create();
      });
  }

  public submit(): void {
    this.formSubmitted = true;
    if (this.createWebsiteForm.invalid) {
      return this.validationFailed.emit();
    }

    this._checkSubdomain();
  }

  private _create(): void {
    this.submitted.emit(this.createWebsiteForm.value);
  }

}
